import { render, staticRenderFns } from "./doc-problems-icon.vue?vue&type=template&id=6379c586&scoped=true&"
import script from "./doc-problems-icon.vue?vue&type=script&lang=js&"
export * from "./doc-problems-icon.vue?vue&type=script&lang=js&"
import style0 from "./doc-problems-icon.vue?vue&type=style&index=0&id=6379c586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6379c586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6379c586')) {
      api.createRecord('6379c586', component.options)
    } else {
      api.reload('6379c586', component.options)
    }
    module.hot.accept("./doc-problems-icon.vue?vue&type=template&id=6379c586&scoped=true&", function () {
      api.rerender('6379c586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/doc-problems-icon.vue"
export default component.exports